import { Fragment, useState } from 'react'
import axios from "axios";
import React from 'react';
import { Dialog, Transition } from '@headlessui/react'
import {
  BanIcon,
  CalendarIcon,
  CogIcon,
  HomeIcon,
  ZoomInIcon,
  MapIcon,
  PhoneIcon,
  PlusIcon,
  UserGroupIcon,
  XCircleIcon,
} from '@heroicons/react/outline'
import { ChevronLeftIcon, EyeIcon, FilterIcon,  StarIcon,UserIcon } from '@heroicons/react/solid'

const tabs = [
  { id:1,name: 'Profile', href: '#', current: true },
  { id:2,name: 'Referral', href: '#', current: false },
]
const timeline = [
  {
    id: 1,
    content: 'Applied to',
    target: 'Front End Developer',
    href: '#',
    date: 'Sep 20',
    datetime: '2020-09-20',
    icon: UserIcon,
    iconBackground: 'bg-gray-400',
  },
  {
    id: 2,
    content: 'Advanced to phone screening by',
    target: 'Bethany Blake',
    href: '#',
    date: 'Sep 22',
    datetime: '2020-09-22',
    icon: UserIcon,
    iconBackground: 'bg-blue-500',
  },
  {
    id: 3,
    content: 'Completed phone screening with',
    target: 'Martha Gardner',
    href: '#',
    date: 'Sep 28',
    datetime: '2020-09-28',
    icon: UserIcon,
    iconBackground: 'bg-green-500',
  },
  {
    id: 4,
    content: 'Advanced to interview by',
    target: 'Bethany Blake',
    href: '#',
    date: 'Sep 30',
    datetime: '2020-09-30',
    icon: UserIcon,
    iconBackground: 'bg-blue-500',
  },
  {
    id: 5,
    content: 'Completed interview with',
    target: 'Katherine Snyder',
    href: '#',
    date: 'Oct 4',
    datetime: '2020-10-04',
    icon: UserIcon,
    iconBackground: 'bg-green-500',
  },
]


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

class CustomerprofileView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerDetails:'',
      customer_id:this.props.CustomerId,
      contact_person:[],
      vehicle_information:[],
      referral_list:[],
      tab_id:1,
    };
  }

  componentDidMount() {
      // const customId = "custom-id-yes";
     //toast("Lorem ipsum dolor",{toastId: customId});
     
     const token = localStorage.getItem("token");
     const res = axios
       .get("public/api/customer/edit/"+this.state.customer_id, {
         headers: {
           authorization: `Bearer ${token}`,
           Accept: "application/json",
         },
       })
       .then((res) => {
         this.state.customerDetails= res.data.customers;
         this.setState({customerDetails: this.state.customerDetails});
         this.setState({contact_person:res.data.customers.customer_contact_person});
         this.setState({vehicle_information:res.data.customers.vehicle_information});
        this.setState({referral_list:res.data.customers.enquires});
        
       });

   }


   tabView=(id,index)=>(e)=>{
    
    this.state.tab_id=id;
    this.setState({tab_id:this.state.tab_id});
        tabs.map((tab)=>{
            console.log(tab.current);
            tab.current=false;
          if(tab.id==id){
            tab.current=true;
          }
        })
   }



    render() 
  {

    const Profile=()=>(
      <>
        {/* Description list */}
        <div className="mx-auto mt-6 max-w-5xl px-4 sm:px-6 lg:px-8 mb-3">
                    <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-4">
                      
                        <div  className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">Name</dt>
                          <dd className="mt-1 text-sm text-gray-900">{this.state.customerDetails?.primary_contact_first_name}{this.state.customerDetails?.primary_contact_last_name}</dd>
                        </div>
                        <div  className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">Email</dt>
                          <dd className="mt-1 text-sm text-gray-900">{this.state.customerDetails?.customer_email}</dd>
                        </div>
                        <div  className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">Mobile</dt>
                          <dd className="mt-1 text-sm text-gray-900">{this.state.customerDetails?.customer_mobile}</dd>
                        </div>
                        <div  className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">Designation</dt>
                          <dd className="mt-1 text-sm text-gray-900">{this.state.customerDetails?.designation}</dd>
                        </div>
                        <div  className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">GSTIN</dt>
                          <dd className="mt-1 text-sm text-gray-900">{this.state.customerDetails?.customer_other_detail?.gstin_uin}</dd>
                        </div> 
                        <div  className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">Department</dt>
                          <dd className="mt-1 text-sm text-gray-900">{this.state.customerDetails?.department}</dd>
                        </div>
                        
                        <div  className="relative sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">Customer Rating</dt>
                          <dd className="float-left	 mt-1 text-sm text-gray-900">{1.5}</dd><StarIcon className='mt-1 h-5 w-5 text-yellow-300 hover:text-yellow-400'/>
                        </div>
                        <div  className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500"></dt>
                          <dd className="mt-1 text-sm text-gray-900">{}</dd>
                        </div>
                       
                      

                      <div className="sm:col-span-1">
                        <dt className="text-sm font-medium text-gray-500">Billing Address</dt>
                        <dd
                          className="mt-1 max-w-prose space-y-5 text-sm text-gray-900"   
                        >{this.state.customerDetails?.customer_address?.billing_address_street_one}<br/>
                         {this.state.customerDetails?.customer_address?.billing_address_street_two}
                        </dd>
                        <dd
                          className="mt-1 max-w-prose space-y-5 text-sm text-gray-900"   
                        >
                         {this.state.customerDetails?.customer_address?.billing_city}{this.state.customerDetails?.customer_address?.billing_city?(','):('')}
                         {this.state.customerDetails?.customer_address?.billing_state_name?.name}
                         
                        </dd>
                        <dd
                          className="mt-1 max-w-prose space-y-5 text-sm text-gray-900"   
                        >
                         {this.state.customerDetails?.customer_address?.billing_country_name?.name}<br/>
                         {this.state.customerDetails?.customer_address?.billing_zip_code}
                        </dd>
                        
                      </div>
                      <div className="sm:col-span-1">
                        <dt className="text-sm font-medium text-gray-500">Shipping Address</dt>
                        <dd
                          className="mt-1 max-w-prose space-y-5 text-sm text-gray-900"   
                        >{this.state.customerDetails?.customer_address?.shipping_address_street_one}<br/>
                         {this.state.customerDetails?.customer_address?.shipping_address_street_two}
                        </dd>
                        <dd
                          className="mt-1 max-w-prose space-y-5 text-sm text-gray-900"   
                        >
                         {this.state.customerDetails?.customer_address?.shipping_city}{this.state.customerDetails?.customer_address?.shipping_city?(','):('')}
                         {this.state.customerDetails?.customer_address?.billing_state_name?.name}
                         
                        </dd>
                        <dd
                          className="mt-1 max-w-prose space-y-5 text-sm text-gray-900"   
                        >
                         {this.state.customerDetails?.customer_address?.shipping_country_name?.name}<br/>
                         {this.state.customerDetails?.customer_address?.shipping_zip_code}
                        </dd>
                        
                      </div>
                    </dl>
                  </div> 
                  <hr/>
                  {/* contact member list */}
                  <div className="mx-auto mt-6 max-w-5xl px-4 sm:px-6 lg:px-8 mb-3 ">
                    <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-4">
                      <div  className="sm:col-span-2 overflow-auto	">
                        <div className="sm:flex-auto">
                          <h3 className="font-medium text-gray-900">Contact Person Info</h3>
                        </div>
                        <table className="min-w-full divide-y divide-gray-300 ">
                          <thead className='bg-gray-50'>
                            <tr>
                            <th
                                scope="col"
                                className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                              >
                                #
                              </th>
                              <th
                                scope="col"
                                className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                              >
                                Name
                              </th>
                              <th
                                scope="col"
                                className=" py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                              >
                                Email
                              </th>
                              <th
                                scope="col"
                                className=" py-3.5 px-3 text-right text-sm font-semibold text-gray-900 sm:table-cell"
                              >
                                Mobile
                              </th>
                            </tr>
                          </thead>
                          <tbody className='divide-y divide-gray-200 bg-white'>
                            {this.state.contact_person.map((project,index) => (
                              <tr key={project.id} className="border-b border-gray-200">
                                <td className=" py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">{index+1}</td>
                                <td className=" py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">{project.contact_person_first_name}</td>
                                <td className=" py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">{project.contact_person_email_address}</td>
                                <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">{project.contact_person_mobile}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        
                      </div>
                      <div  className="sm:col-span-2">
                        <div className="sm:flex-auto">
                          <h3 className="font-medium text-gray-900">Vehicle Info</h3>
                        </div>
                        <table className="min-w-full divide-y divide-gray-300 ">
                          <thead>
                            <tr>
                            <th
                                scope="col"
                                className="py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                              >
                                #
                              </th>
                              <th
                                scope="col"
                                className="py-3.5 pl-4 pr-3 text-right text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                              >
                                Name
                              </th>
                              
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.vehicle_information.map((project,index) => (
                              <tr key={project.id} className="border-b border-gray-200">
                                <td className="py-4 px-3 text-center text-sm text-gray-500 sm:table-cell">{index+1}</td>
                                <td className="py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">{project.vehicle_information}</td>
                                
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </dl>
                  </div>
      </>
    );

    const Reffral=()=>(
      <div className="mx-auto mt-6 max-w-5xl px-4 sm:px-6 lg:px-8 mb-3">
      <div className="flow-root">
      <ul role="list" className="-mb-8">
        {this.state.referral_list.map((event, eventIdx) => (
          <li key={event.id}>
            <div className="relative pb-8">
              {eventIdx !== timeline.length - 1 ? (
                <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" />
              ) : null}
              <div className="relative flex space-x-3">
                <div>
                  <span
                    className='bg-green-500 h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white'
                    
                  >
                    <UserIcon className="h-5 w-5 text-white" aria-hidden="true" />
                  </span>
                </div>
                <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
                  <div>
                    <p className="text-sm text-gray-500">
                      {event.lead?.name}{' '}
                      <a href="#" className="font-medium text-gray-900">
                        {event.lead?.lead_value}
                      </a>
                    </p>
                  </div>
                  <div className="whitespace-nowrap text-right text-sm text-gray-500">
                    {event.lead?.created_at}
                  </div>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
    </div>
    )

   
    return (
      <>

          {/* Static sidebar for desktop */}
          
              <main className="relative z-0 flex-1  focus:outline-none xl:order-last">
                {/* Breadcrumb */}
                <article>
                  {/* Profile header */}
                  <div>
                    
                    <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
                      <div className="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5">
                        
                        <div className="mt-8 sm:flex sm:min-w-0 sm:flex-1 sm:items-center sm:justify-end sm:space-x-6 sm:pb-1">
                          <div className="mt-6 min-w-0 flex-1 sm:hidden 2xl:block">
                            <h1 className="truncate text-2xl font-bold text-gray-900">{this.state.customerDetails?.customer_display_name}</h1>
                          </div>
                          
                        </div>
                      </div>
                      <div className="mt-6 hidden min-w-0 flex-1 sm:block 2xl:hidden">
                        <h1 className="truncate text-2xl font-bold text-gray-900">{this.state.customerDetails?.customer_display_name}</h1>
                      </div>
                    </div>
                  </div>

                  {/* Tabs */}
                  <div className="mt-6 sm:mt-2 2xl:mt-5">
                    <div className="border-b border-gray-200">
                      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
                        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                          {tabs.map((tab) => (
                            <a
                              key={tab.name}
                             
                              onClick={this.tabView(tab.id)}
                              className={classNames(
                                tab.current
                                  ? 'border-pink-500 text-gray-900'
                                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                                'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'
                              )}
                              aria-current={tab.current ? 'page' : undefined}
                            >
                              {tab.name}
                            </a>
                          ))}
                        </nav>
                      </div>
                    </div>
                  </div>

                  {this.state.tab_id==1?(<Profile/>):('')}
                  {this.state.tab_id==2?(<Reffral/>):('')}
                </article>
              </main>
            
        
        
      </>
    );

  }
}

export default CustomerprofileView;